// libraries
import keymirror from 'keymirror'

export const FORM_GALLERY_VIEWS = keymirror({ form: null, formList: null })

export type FormGalleryView = keyof typeof FORM_GALLERY_VIEWS
